<template>
  <div>
    <b-tabs>
      <b-tab title="Карти клиєнтів">
        <clients-with-cards />
      </b-tab>
      <b-tab title="Дні народження">
        <birthday-list />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BirthdayList from "@/components/lists/BirthdayList";
import ClientsWithCards from "@/components/lists/ClientsWithCards";
export default {
  name: "Marketing",
  components: {
    BirthdayList,
    ClientsWithCards,
  },
};
</script>

<style scoped></style>
